import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Nav } from '../interface/Nav';
import { OrderDetails } from '../components/orderComponent/OrderDetails';
import { Socials } from '../interface/Socials';
import corp from '../assets/logo.svg';
import corpWhite from '../assets/logo_white.svg';
import footIcon from '../assets/dicont_foot_icon.svg';
import footIconWhite from '../assets/dicont_foot_icon_white.svg';
import api from '../services/apiCalls.service';



let theme = 'white';
let discontText = '10%';
let descriptionText = 'BLACK FRIDAY';

const styleTheme = {
  white: {
    text: '#191919',
    altText: '#CECECE',
    corp: corp,
    footIcon: footIcon,
    fon: '#CECECE',
  },
  black: {
    text: '#CECECE',
    altText: '#383838',
    corp: corpWhite,
    footIcon: footIconWhite,
    fon: '#191919',
  },
  green: {
    text: '#191919',
    altText: '#CECECE',
    corp: corp,
    footIcon: footIcon,
    fon: '#00FF06',
  },
}


const Wrapper = styled.div`
  height: 100%;
  width: 100vw;
  background-color: rgba(0,0,0,0.55);
  position: fixed;
  top:0;
  left:0;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex-wrap: wrap;
  z-index: 21;
  transition: 0.7s;

`;

const MainBlock = styled.div`
  height: 701px;
  width: 440px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  transition: 0.8s;
  @media screen and (max-width: 567px) {
    height: 560.8px;
    width: 352px;
  }
`;

const Block = styled.div`
  height: 640px;
  width: 440px;
  background-color: ${styleTheme[theme].fon};
  clip-path: polygon( 95.98% 0.14%,56.828% 0.14%,56.828% 0.14%,56.59% 0.144%,56.353% 0.154%,56.117% 0.171%,55.882% 0.195%,55.649% 0.225%,55.418% 0.262%,55.19% 0.306%,54.964% 0.356%,54.741% 0.412%,54.522% 0.475%,54.522% 0.475%,54.306% 0.544%,54.095% 0.619%,53.889% 0.7%,53.688% 0.787%,53.493% 0.88%,53.304% 0.977%,53.12% 1.081%,52.943% 1.189%,52.772% 1.303%,52.608% 1.421%,48.753% 4.326%,4.159% 4.326%,4.159% 4.326%,3.83% 4.337%,3.505% 4.365%,3.186% 4.41%,2.874% 4.472%,2.57% 4.551%,2.276% 4.646%,1.993% 4.756%,1.723% 4.881%,1.467% 5.022%,1.227% 5.177%,1.227% 5.177%,1.005% 5.344%,0.804% 5.522%,0.625% 5.709%,0.468% 5.905%,0.334% 6.108%,0.223% 6.318%,0.137% 6.534%,0.075% 6.754%,0.038% 6.978%,0.027% 7.204%,0.027% 96.658%,0.027% 96.658%,0.03% 96.788%,0.04% 96.918%,0.057% 97.047%,0.082% 97.176%,0.114% 97.304%,0.153% 97.43%,0.199% 97.556%,0.253% 97.681%,0.314% 97.804%,0.382% 97.925%,0.382% 97.925%,0.456% 98.045%,0.538% 98.162%,0.626% 98.277%,0.72% 98.389%,0.821% 98.498%,0.927% 98.605%,1.04% 98.709%,1.159% 98.81%,1.283% 98.908%,1.414% 99.002%,1.414% 99.002%,1.549% 99.093%,1.69% 99.18%,1.835% 99.262%,1.984% 99.341%,2.138% 99.416%,2.296% 99.487%,2.458% 99.553%,2.624% 99.615%,2.793% 99.672%,2.966% 99.725%,2.966% 99.725%,3.142% 99.773%,3.32% 99.816%,3.5% 99.855%,3.682% 99.888%,3.866% 99.917%,4.051% 99.941%,4.238% 99.959%,4.425% 99.973%,4.614% 99.981%,4.803% 99.984%,95.433% 99.984%,95.433% 99.984%,95.606% 99.981%,95.778% 99.974%,95.95% 99.961%,96.12% 99.944%,96.29% 99.923%,96.458% 99.897%,96.624% 99.866%,96.789% 99.831%,96.952% 99.791%,97.113% 99.747%,97.113% 99.747%,97.271% 99.699%,97.426% 99.646%,97.577% 99.59%,97.726% 99.529%,97.87% 99.465%,98.011% 99.396%,98.148% 99.324%,98.28% 99.248%,98.409% 99.169%,98.533% 99.086%,98.533% 99.086%,98.652% 98.999%,98.766% 98.91%,98.874% 98.818%,98.977% 98.723%,99.075% 98.625%,99.167% 98.525%,99.253% 98.422%,99.334% 98.317%,99.408% 98.21%,99.476% 98.101%,99.476% 98.101%,99.538% 97.99%,99.594% 97.877%,99.643% 97.763%,99.685% 97.648%,99.721% 97.532%,99.751% 97.416%,99.773% 97.298%,99.789% 97.18%,99.798% 97.061%,99.8% 96.942%,99.8% 2.808%,99.8% 2.808%,99.79% 2.598%,99.756% 2.391%,99.699% 2.188%,99.619% 1.988%,99.517% 1.794%,99.393% 1.606%,99.248% 1.424%,99.082% 1.251%,98.897% 1.086%,98.691% 0.931%,98.691% 0.931%,98.469% 0.787%,98.232% 0.657%,97.983% 0.541%,97.721% 0.438%,97.45% 0.35%,97.169% 0.277%,96.88% 0.219%,96.585% 0.177%,96.284% 0.151%,95.98% 0.14% );
  display: flex;
  align-items: center;
  flex-direction: column;

  @media screen and (max-width: 567px) {
    height: 512px;
    width: 352px;
  }
`;

const CloseButton = styled.div`
  height: 37px;
  width: 92px;
  padding: 10px;
  text-align:center;
  font-family: Fira Code;
  font-size: 13.2px;
  font-weight: 400;
  line-height: 17.32px;
  color: rgba(206, 206, 206, 1);
  cursor: pointer;
`;

const Discont = styled.div`
  margin-top: 271px;
  height: 75px;
  font-family: Chakra Petch;
  font-size: 57.39px;
  font-weight: 500;
  line-height: 74.61px;
  text-align:center;
  color: ${styleTheme[theme].text};
  display: flex;
  align-items: start;

  @media screen and (max-width: 567px) {
    margin-top: 216.8px;
    font-size: 45.9px;
    line-height: 59.68px;
  }
`;

const LeftBlock = styled.div`
  margin-top: 12.31px;
  width: 27px;
  height: 20px;

`;

const OffBlock = styled.div`
  margin-left: 5px;
  margin-top: 12.31px;
  width: 27px;
  height: 20px;
  font-family: Fira Code;
  font-size: 14.96px;
  font-weight: 700;
  line-height: 19.63px;
  color: ${styleTheme[theme].text};

  @media screen and (max-width: 567px) {
    margin-left: 4px;
    margin-top: 11.25px;
    font-size: 11.97px;
    line-height: 15.7px;
  }
`;

const Description = styled.div`
  margin-top: 6.16px;
  width: 90%;
  height: 26px;
  font-family: Fira Code;
  font-size: 20px;
  font-weight: 700;
  line-height: 26.24px;
  text-align: center;
  color: ${styleTheme[theme].text};

  @media screen and (max-width: 567px) {
    margin-top: 5px;
    height: 20.8px;
    font-size: 16px;
    line-height: 20.99px;
  }
`;

const Slogan = styled.div`
  margin-top: 93.69px;
  width: 279px;
  height: 26px;
  font-family: Fira Code;
  font-size: 20px;
  font-weight: 700;
  line-height: 26.24px;
  text-align: left;
  color: ${styleTheme[theme].text};
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media screen and (max-width: 567px) {
    margin-top: 74.9px;
    width: 223.2px;
    height: 20.8px;
    font-size: 16px;
    line-height: 20.99px;
  }
`;
const SloganText = styled.div`

  width: 144px;
  height: 26px;
  font-family: Fira Code;
  font-size: 20px;
  font-weight: 700;
  line-height: 26.24px;
  text-align: left;
  color: ${styleTheme[theme].text};
  @media screen and (max-width: 567px) {
    height: 20.8px;
    font-size: 16px;
    line-height: 20.99px;
  }
`;

const ImageLogo = styled.img`
  width: 107.8px;
  @media screen and (max-width: 567px) {
    width: 86.24px;
  }
`;

const Button = styled.div`
  margin-top: 15.46px;
  width: 369px;
  height: 49px;
  font-family: Fira Code;
  font-size: 16.8px;
  font-weight: 450;
  line-height: 22.04px;
  text-align: center;
  background: ${styleTheme[theme].text};
  color: ${styleTheme[theme].altText};
  display:flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  @media screen and (max-width: 567px) {
    margin-top: 12.4px;
    width: 295px;
    height: 39.2px;
    font-size: 13.44px;
    line-height: 17.63px;
  }
`;



const Footer = styled.div`
  margin-top: 17.59px;
  width: 369px;
  height: 27px;
  display:flex;
  align-items: center;
  justify-content: start;

  @media screen and (max-width: 567px) {
    margin-top: 14px;
    width: 295px;
    height: 21.6px;
  }
`;
const ImageFootIcon = styled.img`
  width: 25.91px;

  @media screen and (max-width: 567px) {
    width: 20.73px;
  }
`;
const FooterText = styled.div`
  margin-left: 11.42px;
  width: 317px;
  height: 27px;
  font-family: Fira Code;
  font-size: 10.15px;
  font-weight: 400;
  line-height: 13.32px;
  text-align: left;
  color: ${styleTheme[theme].text};

  @media screen and (max-width: 567px) {
    margin-left: 9.13px;
    width: 253.6px;
    height: 21.6px;
    font-size: 8.12px;
    line-height: 10.65px;
  }
`;




export const ModalContainer = ({props , active, setActive}) => {
  //console.log(props)
  theme = props.theme;
  discontText = props.discont;
  descriptionText = props.description;



  const copyTextToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      //console.log('Текст успешно скопирован в буфер обмена!');
    } catch (err) {
      //console.error('Ошибка:', err);
    }
  };






	return (
		<Wrapper onClick={()=> setActive(false)} style={active ? {opacity: 1, pointerEvents: 'all'} : {opacity: 0, pointerEvents: 'none'}}>
      <MainBlock onClick={e => e.stopPropagation() } style={active ? {opacity: 1, marginLeft: "0%", pointerEvents: 'all'} : {opacity: 0, marginLeft: "200%", pointerEvents: 'none'}}>
        <Block style={{backgroundColor: `${props.fon}`}} >
          <Discont style={{color: `${styleTheme[theme].text}`}} >
            <LeftBlock></LeftBlock>
            {discontText}
            <OffBlock style={{color: `${styleTheme[theme].text}`}} >
            OFF
            </OffBlock>
          </Discont>
          <Description style={{color: `${styleTheme[theme].text}`}}>
            {descriptionText}
          </Description>
          <Slogan style={{color: `${styleTheme[theme].text}`}}>
            <SloganText style={{color: `${styleTheme[theme].text}`}}>
            GO FIND YOUR
            </SloganText>
            <ImageLogo src={styleTheme[theme].corp} alt='Nerv_logo' />
          </Slogan>
          <Button onClick={()=>{copyTextToClipboard(props.code)}} style={{color: `${styleTheme[theme].altText}`, background: `${styleTheme[theme].text}` }} >
          COPY
          </Button>
          <Footer>
            <ImageFootIcon src={styleTheme[theme].footIcon} alt='Nerv_footer_icon' />
            <FooterText style={{color: `${styleTheme[theme].text}`}} >
              THIS PROMO YOU CAN USE ONLY FOR THE 1 (ONE) PURCHASE
              PLEASE NOTE! THE CODE IS ALREADY ACTIVE IN YOUR CART
            </FooterText>
          </Footer>

        </Block>
        <CloseButton onClick={()=> setActive(false)}>[ CLOSE ]</CloseButton>
      </MainBlock>
		</Wrapper>
	);
};
